/*global angular */
'use strict';

angular.module('MrDWebApp').controller('ExceptionsCtrl', function ($scope, $state, $rootScope, $previousState, order, status) {

  var _exc = this;

  $previousState.memo('caller');

  _exc.previousState = $previousState.get('caller');

  $scope._rc.bodyClass = 'html-exceptions';

  $rootScope.$broadcast('loading:show');

  _exc.isLoading = true;
  _exc.status = status;
  _exc.order = order;
  
  order.$promise.then(function () {
    _exc.isLoading = false;
    $rootScope.$broadcast('loading:hide');
    $scope._rc.bodyClass = 'html-exceptions html-exceptions-'+_exc.order.status;

    // Testing
    //_exc.order.status = 'failed_restaurant_injection';
    //_exc.order.status = $state.params.statusID;
    //_exc.order.failed_reason = 'reason';

  });

  _exc.backToHistory = function(){
    $state.go(_exc.previousState.state.name,_exc.previousState.params);
  };


  _exc.newOrderButtonClick = function(){

    $scope._rc.newOrderSoft();
    if ($scope._rc.variables.address.street_name){ // check for only street-name here. Assuming the rest..
      $state.go('location',{
        lat: $scope._rc.variables.address.latitude,
        lng: $scope._rc.variables.address.longitude,
        street_name: $scope._rc.variables.address.street_name
      });
    } else {
      if (window.env.domainSplit) window.location.href = '/'; else $state.go('home');
    }
    
  };


});
